import React, { useState, Component } from 'react'
import { Link } from 'react-router-dom'
import { Nav, Navbar, NavDropdown, Form, FormControl, Button, NavItem, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { AuthUserContext } from '../components/Session'
import { withFirebase } from '../components/Firebase'
import AuthenticationModel from '../pages/NavigationAuthentication'
{
  // let { i18n } = useTranslation()
  // let changeLanguage = lng => {
  //   i18n.changeLanguage(lng)
  // };
}
const Page = (props) => (
  <>
        <Navbar bg="white" expand="md" fixed="top" variant="light" >
            <div className="container">
            {/* <Navbar.Brand href="#home">React-Bootstrap</Navbar.Brand> */}
            <Navbar.Brand href="/"><img src={'/app/logo/android-chrome-512x512.png'} style={{maxHeight:"50px"}} className="" alt="logo" /></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                    {/* <Nav.Link href="#home">Home</Nav.Link> */}



                    <NavDropdown title="เจ้าของรถ">
                            <NavDropdown.Item href="../carSearch">ค้นหารถ</NavDropdown.Item>
                          </NavDropdown>
                    <AuthUserContext.Consumer>
                    {authUser =>
                      authUser ? (
                        <>
                          
                          { authUser && authUser.roles && (!!authUser.roles["police_station"] || !!authUser.roles["ADMIN"])  && (
                            <>
                              <NavDropdown title="สำนักงานตำรวจ">
                                <NavDropdown.Item href="../carSearch">ค้นหารถ</NavDropdown.Item>
                                <NavDropdown.Item href="../carList">รายการรถ</NavDropdown.Item>
                                <NavDropdown.Item href="../carDemoReport">รายงานภาพรวม</NavDropdown.Item>
                            </NavDropdown>
                            </>
                          )}
                          { authUser && authUser.roles && (!!authUser.roles["police_officer"] || !!authUser.roles["ADMIN"])  && (
                            <>
                              <NavDropdown title="พนักงานจราจร">
                                <NavDropdown.Item href="../carSearch">ค้นหารถ</NavDropdown.Item>
                                <NavDropdown.Item href="../carList">รายการรถ</NavDropdown.Item>
                              </NavDropdown>
                            </>
                          )}
                          { authUser && authUser.roles && (!!authUser.roles["admin"] || !!authUser.roles["ADMIN"])  && (
                            <>
                              <NavDropdown title="ผู้ประสานงาน (Admin)">
                                <NavDropdown.Item href="../carSearch">ค้นหารถ</NavDropdown.Item>
                                <NavDropdown.Item href="../carListForAdmin">จัดการรถ</NavDropdown.Item>
                                <NavDropdown.Item href="../carDemoReport">รายงานภาพรวม</NavDropdown.Item>
                                {/* <NavDropdown.Item href="../carAdd">เรียกรถลาก</NavDropdown.Item> */}
                              </NavDropdown>
                            </>
                          )}
                          { authUser && authUser.roles && (!!authUser.roles["towing"] || !!authUser.roles["ADMIN"])  && (
                            <>
                              <NavDropdown title="รถลากจูง">
                                <NavDropdown.Item href="../carSearch">ค้นหารถ</NavDropdown.Item>
                                <NavDropdown.Item href="../carListForTowing">รายการเรียกรถลาก</NavDropdown.Item>
                                {/* <NavDropdown.Item href="../carList">รายการรถ ไปลาก/ยก </NavDropdown.Item> */}
                              </NavDropdown>
                            </>
                          )}
                          { authUser && authUser.roles && (!!authUser.roles["parking"] || !!authUser.roles["ADMIN"])  && (
                            <>
                              <NavDropdown title="ลานจอดรถ">
                                <NavDropdown.Item href="../carSearch">ค้นหารถ</NavDropdown.Item>
                                <NavDropdown.Item href="../carListForParking">รายการรถฝากจอด</NavDropdown.Item>
                                {/* <NavDropdown.Item href="../carList">รายการรถ ฝากจอด</NavDropdown.Item> */}
                              </NavDropdown>
                            </>
                          )}





                          

                        </>
                      ) : ""
                    }
                  </AuthUserContext.Consumer>
                </Nav>
                <Nav className="">
                {/* <Form inline>
                    <FormControl type="text" placeholder="Search" className="mr-sm-2" />
                    <Button variant="outline-success">Search</Button>
                </Form> */}
                {/* <Nav.Link href="#about">{i18n.t('MENU.ABOUT')}</Nav.Link>
                <Nav.Link href="#contact">{i18n.t('MENU.CONTACT')}</Nav.Link> */}
                {/* <NavDropdown title="Language" className="">
                    <NavDropdown.Item href="/" onClick={() => changeLanguage('en')}>English</NavDropdown.Item>
                    <NavDropdown.Item href="/" onClick={() => changeLanguage('th')}>Thai</NavDropdown.Item>
                </NavDropdown> */}
                <AuthUserContext.Consumer>
                  { authUser=>
                    <AuthenticationModel firebase={props.firebase} authUser={authUser}/>
                  }
                </AuthUserContext.Consumer>
                {/* <Button variant="outline-primary" onClick={setShow(true)}>Sign In</Button> */}
                </Nav>
                {/* <Form inline>
                  <FormControl type="text" placeholder="User" className="mr-sm-1" />
                  <FormControl type="password" placeholder="Pass" className="mr-sm-1" />
                  <Button variant="outline-success">Sign In</Button>
                </Form> */}
                
            </Navbar.Collapse>
            </div>
        </Navbar>

        
      </>
)

export default withFirebase(Page)

  



